
<div class="folderInDetail" *ngIf="folderDetails != '' && folderDetails != undefined">
  <div class="iconUser" *ngIf="folderDetails.isFile==false">
    <mat-icon *ngIf="isShared != 'true'">folder</mat-icon>
    <mat-icon *ngIf="isShared == 'true'">folder_shared</mat-icon>
    <div class="nmFile">
      <h4>{{ folderDetails.name }}</h4>
      <span class="filecount">{{ folderDetails.count }} Items</span>
    </div>
  </div>

  <div class="iconUser" *ngIf="folderDetails.isFile==true">
    <mat-icon>description</mat-icon>
    <div class="nmFile">
      <h4>{{ folderDetails.name }}</h4>
    </div>
  </div>

  <div class="userlist" *ngIf="isSharedWithMeFileManager!='true'">
    <button mat-icon-button [matMenuTriggerFor]="mainfolder">
      <mat-icon>more_vertical</mat-icon>
    </button>
    <mat-menu #mainfolder="matMenu" xPosition="before">
      <button mat-menu-item (click)=" renameFileManagerItem(folderDetails)">
        <mat-icon>format_size</mat-icon> Rename
      </button>
      <button mat-menu-item (click)="MoveTo(folderDetails)"><mat-icon>low_priority</mat-icon> Move to</button>
      <button mat-menu-item *ngIf="folderDetails.isFile==false" (click)="DeleteFolders(folderDetails)">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
      <button mat-menu-item *ngIf="folderDetails.isFile==true" (click)="DeleteFile(folderDetails)">
        <mat-icon>delete_outline</mat-icon> Delete
      </button>
    </mat-menu>
  </div>
</div>


<mat-tab-group [selectedIndex]="tabType" mat-align-tabs="start" *ngIf="folderDetails != '' && folderDetails != undefined"
 animationDuration="0ms" (selectedTabChange)="onTabClick($event)">   
    <mat-tab label="Detail"> 
      <div class="folderInDetail alldetail">
          <div class="metadetails">
            <div class="fileTypecount" *ngIf="isSharedWithMeFileManager != 'true'">
            
              <ng-container *ngIf="SharedContactRoleCount != 0">
                <p>Shared with</p>
                <div class="userlist">                  
                 <div class="userCount" (click)="showSharedContactRoleList()" matTooltipClass="tooltip">
                    {{ SharedContactRoleCount }}
                  </div>
                </div>
              </ng-container>
  
              <ng-container *ngIf="SharedContactRoleCount == 0">
                <div class="userlist">
                  <p>Private</p>
                </div>
              </ng-container>                     
              
            </div>
            <div class="info meta">
              <p *ngIf="folderDetails.isFile==false"><span>Folder Name</span>{{ folderDetails.name }}</p>
              <p *ngIf="folderDetails.isFile==true"><span>File Name</span>{{ folderDetails.name }}</p>
              <p *ngIf="folderDetails.isFile==false"><span>Type</span>Folder</p>
              <p *ngIf="folderDetails.isFile==true"><span>Type</span>File</p>             
              <p *ngIf="folderDetails.createdOn!=null"><span>Created Date</span>{{ folderDetails.createdOn+'Z' | date: "MM/dd/yyyy h:mm a" }}</p>
              <p *ngIf="folderDetails.isFile==false"><span>AI Automation Template Name</span>{{ folderDetails.aiaUtomationTemplateName}}</p>
            </div>

            <br>
            
            <div  *ngIf="fileFoldeTypeId==2">
      
              <!-- <div class="fullw"> -->
                <mat-form-field>
                  <mat-label>Document Type</mat-label>
                     <mat-select [(ngModel)]="TypeIdDrp" (selectionChange)="onDocumentTypeChange($event)">
                       <mat-option *ngFor="let data of documentTypeList" [value]="data.documentTypeID">
                       {{data.documentTypeName}}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              <!-- </div> -->
  
              <form [formGroup]="myFormGroup" class="fullw">
                  
      
                <ng-container *ngFor="let field of coreUserList">
                  <div *ngIf="field.fieldID==0 && field.data.length>0" class="fullw groupHolder"
                    [ngSwitch]="field.fieldTypeName">
                    <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{field.data[0].groupName}}
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <div *ngFor="let grpField of field.data">
      
                        <div *ngIf="grpField.fieldID>0" class="fullw" [ngSwitch]="grpField.fieldTypeName">
                          <ng-container *ngSwitchCase="'Textbox'">
                            <ng-container *ngIf="grpField.fieldName == 'Name'">
                              <mat-form-field>
                                <input matInput [required]="grpField.isRequired" placeholder="{{ grpField.fieldName }}"
                                  [(ngModel)]="transactionUserName" formControlName="{{ grpField.fieldName }}"
                                  [readonly]="grpField.rolePermission==1" />
      
      
                              </mat-form-field>
                            </ng-container>
      
                            <ng-container *ngIf="grpField.fieldName != 'Name'">
                              <ng-container *ngIf="grpField.fieldNames.length > 0">
                                <div class="multipleBlock">
                                  <div class="multype">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)"
                                        formControlName="{{ grpField.fieldName + 'option' }}"
                                        placeholder="{{ grpField.placeholderVal }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of grpField.fieldNames">
                                          {{ names.fieldName }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field>
                                      <input [required]="grpField.isRequired" *ngIf="grpField.fieldName == 'Phone'" matInput
                                        placeholder="Add Phone" [(ngModel)]="grpField.fieldValue"
                                        formControlName="{{ grpField.fieldName }}" mask="(000) 000-0000"
                                        [readonly]="grpField.rolePermission==1" />
                                      <input [required]="grpField.isRequired" *ngIf="grpField.fieldName != 'Phone'" matInput
                                        placeholder="Add {{ grpField.placeholder }}" [(ngModel)]="grpField.fieldValue"
                                        formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                    </mat-form-field>
      
                                    <div class="inOline" *ngIf="grpField.fieldName == 'Address'">
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number"
                                            matInput (input)="searchCity($event.target.value)" formControlName="City"
                                            [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of cityOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <mat-select [disabled]="grpField.rolePermission==1" [(ngModel)]="stateValue"
                                            formControlName="State" placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <input type="text" placeholder="Zip Code" aria-label="Number" [(ngModel)]="zipValue"
                                            matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                            [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #ZipCode="matAutocomplete">
                                            <mat-option *ngFor="let option of zipOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
      
      
                                    </div>
      
      
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                    *ngIf="grpField.fieldNames.length > 0">
                                    Add more</span>
                                </div>
      
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Email'">
                                  <div class="multype" *ngFor="let element of dynamicArray; let i = index">
      
      
                                    <div class="primaryEmail">
                                      <mat-form-field class="mulDropdown" appearance="">
                                        <mat-select (selectionChange)="clearPlaceholder($event)"
                                          formControlName="{{element.fieldName + 'option'}}"
                                          placeholder="{{ element.placeholderVal }}">
                                          <mat-option value="{{ names.fieldNameID }}" *ngFor="let names of element.fieldNames;
                                              trackby: fieldNameID">{{ names.fieldName }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
      
                                      <!-- <div class="setPrimary" matTooltip="Set as primary email" matTooltipClass="tooltip"> Primary</div> -->
      
                                    </div>
      
                                    <mat-form-field>
                                      <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                        formControlName="{{ element.fieldName}}" [readonly]="grpField.rolePermission==1"
                                        pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                                    </mat-form-field>
      
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                    *ngIf="grpField.fieldNames.length > 0">
                                    Add more</span>
                                </div>
      
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Phone'">
                                  <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName  + 'option'
                                        }}" placeholder="{{ grpField.fieldNames[0].fieldName }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                    <mat-form-field>
                                      <input matInput mask="(000) 000-0000" [(ngModel)]="element.fieldValue"
                                        placeholder="Add Phone" formControlName="{{ element.fieldName }}"
                                        [readonly]="grpField.rolePermission==1" />
                                    </mat-form-field>
      
      
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                    *ngIf="grpField.fieldNames.length > 0">
                                    Add more</span>
                                </div>
      
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'Address'">
                                  <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                        formControlName="{{
                                          element.fieldName + 'option'
                                        }}" placeholder="{{ element.placeholderVal }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
      
                                    <mat-form-field>
                                      <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                        formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                    </mat-form-field>
      
                                    <div *ngIf="element.address.length>0" class="inOline">
                                      <ng-container *ngFor=" let adr of element.address;">
      
      
                                        <!-- <div class="divide">
                                        <mat-form-field> -->
                                        <input *ngIf="adr.childFieldType==3" placeholder="City" aria-label="Number" matInput
                                          [ngModel]="adr.fieldValue" (input)="searchCity($event.target.value)"
                                          formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                          [readonly]="grpField.rolePermission==1">
                                        <mat-autocomplete #auto="matAutocomplete">
                                          <mat-option *ngFor="let option of cityOption" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                        <!-- </mat-form-field>
                                      </div> -->
      
                                        <!-- <div class="divide">
                                        <mat-form-field> -->
                                        <mat-select [disabled]="grpField.rolePermission==1" [ngModel]="adr.fieldValue"
                                          *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}"
                                          placeholder="State">
                                          <mat-option>None</mat-option>
                                          <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                        </mat-select>
                                        <!-- </mat-form-field>
                                      </div> -->
      
      
                                        <!-- <div class="divide">
                                        <mat-form-field> -->
                                        <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                          aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                          formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                          [readonly]="grpField.rolePermission==1">
                                        <mat-autocomplete #ZipCode="matAutocomplete">
                                          <mat-option *ngFor="let option of zipOption" [value]="option">
                                            {{option}}
                                          </mat-option>
                                        </mat-autocomplete>
                                        <!-- </mat-form-field>
                                      </div> -->
      
      
                                      </ng-container>
                                    </div>
                                    <div *ngIf="element.address.length==0" class="inOline">
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <input placeholder="City" aria-label="Number" matInput
                                            (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                            [matAutocomplete]="auto" [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of cityOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <mat-select [disabled]="grpField.rolePermission==1"
                                            formControlName="State{{ (i + 1) }}" placeholder="State">
                                            <mat-option>None</mat-option>
                                            <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
      
                                      <div class="divide">
                                        <mat-form-field>
                                          <input placeholder="Zip Code" aria-label="Number" matInput
                                            (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                            [matAutocomplete]="ZipCode" [readonly]="grpField.rolePermission==1">
                                          <mat-autocomplete #ZipCode="matAutocomplete">
                                            <mat-option *ngFor="let option of zipOption" [value]="option">
                                              {{option}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field>
                                      </div>
      
      
      
      
                                    </div>
      
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                    *ngIf="grpField.fieldNames.length > 0">
                                    Add more</span>
                                </div>
      
                                <div class="multipleBlock" *ngIf="grpField.fieldName == 'WebSite'">
                                  <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                                    <mat-form-field class="mulDropdown" appearance="">
                                      <mat-select (selectionChange)="clearPlaceholder($event)" formControlName="{{
                                          element.fieldName + 'option'
                                        }}">
                                        <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                            let names of element.fieldNames;
                                            trackby: fieldNameID
                                          ">{{ names.fieldName }}</mat-option>
                                      </mat-select>
                                    </mat-form-field>
      
      
                                    <mat-form-field>
                                      <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                        formControlName="{{ element.fieldName }}" [readonly]="grpField.rolePermission==1" />
                                    </mat-form-field>
      
      
                                  </div>
                                  <span class="addmore" (click)="addMore(grpField.fieldName)"
                                    *ngIf="grpField.fieldNames.length > 0">
                                    Add more</span>
                                </div>
                              </ng-container>
      
                              <mat-form-field *ngIf="grpField.fieldNames.length === 0">
                                <mat-label>{{ grpField.fieldName }}</mat-label>
                                <input matInput [required]="grpField.isRequired" placeholder="Add {{ grpField.fieldName }}"
                                  formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                              </mat-form-field>
                            </ng-container>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Textarea'">
                            <mat-form-field>
                              <textarea [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1">
                              </textarea>
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Number'">
                            <mat-form-field>
                              <input [required]="grpField.isRequired" matInput (keypress)="numberOnly($event)"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                                [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Currency'">
                            <mat-form-field>
                              <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Address'">
                            <mat-form-field>
                              <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Image'">
                            <mat-label>{{ grpField.fieldName }}</mat-label>
                            <div class="pic">
                              <input type="file" placeholder="{{ grpField.fieldName }}"
                                formControlName="{{ grpField.fieldName }}" (change)="onSelectFile($event)"
                                [readonly]="grpField.rolePermission==1" />
                              <span class="ico">
                                <mat-icon>add_a_photo</mat-icon>
                              </span>
                            </div>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Date'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <input [required]="grpField.isRequired" matInput [matDatepicker]="basicDatepicker"
                                placeholder="{{ grpField.fieldName }}" formControlName="{{ grpField.fieldName }}"
                                [readonly]="grpField.rolePermission==1" />
                              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker #basicDatepicker></mat-datepicker>
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'URL'">
                            <mat-form-field>
                              <input [required]="grpField.isRequired" matInput placeholder="{{ grpField.fieldName }}"
                                formControlName="{{ grpField.fieldName }}" [readonly]="grpField.rolePermission==1" />
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'Dropdown'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-select [disabled]="grpField.rolePermission==1"
                                [ngModel]="getddlSelectedVal(grpField.fieldName)" [required]="grpField.isRequired"
                                formControlName="{{ grpField.fieldName }}">
                                <mat-option *ngFor="let drp of getdropdownlist(grpField.fieldName)" [value]="drp">
                                  {{ drp }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </ng-container>
      
                          <ng-container *ngSwitchCase="'MultiSelect'">
                            <mat-form-field class="example-chip-list" *ngIf="grpField.fieldName == 'Tags'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-chip-list [required]='grpField.isRequired' #chipList aria-label="Tag selection">
                                <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                                  (removed)="remove(tag)">
                                  {{tag}}
                                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                </mat-chip>
                                <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                  (matChipInputTokenEnd)="add($event)">
                              </mat-chip-list>
                              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                                  {{tag}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
      
                            <mat-form-field *ngIf="grpField.fieldName != 'Tags'">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-select [disabled]="grpField.rolePermission==1" [required]='grpField.isRequired' multiple
                                [ngModel]="getMultiddlSelectedVal(grpField.fieldName)"
                                formControlName="{{ grpField.fieldName }}">
                                <mat-option *ngFor="
                                    let muldrp of getMuldropdownlist(grpField.fieldName)
                                  " [value]="muldrp">
                                  {{ muldrp }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
      
                          </ng-container>
      
                          <!-- <ng-container *ngSwitchCase="'MultiSelect'">
                            <mat-form-field>
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-select [disabled] = "grpField.rolePermission==1" [required]="grpField.isRequired"
                              [ngModel]="getMultiddlSelectedVal(grpField.fieldName)" multiple formControlName="{{ grpField.fieldName }}">
                                <mat-option
                                  *ngFor="let muldrp of getMuldropdownlist(grpField.fieldName)"
                                  [value]="muldrp">
                                  {{ muldrp }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </ng-container> -->
      
                          <!-- <ng-container *ngSwitchCase="'MultiSelect' && grpField.fieldName ==='Tags'">
                            <mat-form-field class="example-chip-list">
                              <mat-label>{{ grpField.fieldName }}</mat-label>
                              <mat-chip-list [required]="grpField.isRequired" #chipList aria-label="Fruit selection">
                                <mat-chip
                                  *ngFor="let fruit of filteredFruits"
                                  [selectable]="selectable"
                                  [removable]="removable"
                                  (removed)="remove(fruit)">
                                  {{fruit}}
                                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                </mat-chip>
                                <input
                                  placeholder="Add Tags"
                                  #fruitInput
                                  [formControl]="fruitCtrl"
                                  [matAutocomplete]="auto"
                                  [matChipInputFor]="chipList"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                  (matChipInputTokenEnd)="add($event)"
                                  [readonly] = "grpField.rolePermission==1">
                              </mat-chip-list>
                              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                <mat-option *ngFor="let fruit of filteredFruits | async" [value]="fruit">
                                  {{fruit}}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </ng-container>                     -->
      
      
                          <ng-container *ngSwitchCase="'Checkbox'">
                            <mat-label>{{ grpField.fieldName }}</mat-label>
                            <ul class="check">
                              <li *ngFor="let chk of getCheckBoxlist(grpField.fieldName)">
                                <mat-checkbox color="primary" [disabled]="grpField.rolePermission==1"
                                  [checked]="isChecked(grpField.fieldName, chk)"
                                  (change)="OnChange($event, chk, grpField.fieldID)">
                                  {{ chk }}
                                </mat-checkbox>
                              </li>
                            </ul>
                          </ng-container>
      
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </div>
      
                  <div [ngSwitch]="field.fieldTypeName" class="fullw" *ngIf="field.fieldID > 0">
      
                    <div *ngSwitchCase="'Textbox'">
      
                      <!-- <ng-container *ngIf="field.fieldNames.length > 0">
                        <ng-container>
                          <div class="multipleBlock">
                            <div class="multype">
                             
                              <div class="forAddress">
                               
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="field.fieldNameID" formControlName="{{ field.fieldName + 'option' }}">
                                    <mat-option [value]="names.fieldNameID" *ngFor="
                                        let names of field.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
                              
      
                              </div>
                              <mat-form-field>
                                <input [required]='field.isRequired' *ngIf="field.fieldName == 'Phone'" matInput
                                  placeholder="Add Phone" [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}" mask="(000) 000-0000"
                                  [readonly]="field.rolePermission==1" />
                                <input [required]='field.isRequired' *ngIf="field.fieldName == 'Email'" matInput
                                  placeholder="Add Email" [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                                <input [required]='field.isRequired' *ngIf="field.fieldName == 'Address'" matInput
                                  placeholder="Add Address" [(ngModel)]="field.fieldValue"
                                  formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
      
                                  <div class="" *ngIf="field.fieldName == 'Address'">
      
        
                                    <button mat-icon-button color="primary" class="addressPin" (click)="showLocationOnMap(field.fieldValue)">
                                      <mat-icon>pin_drop</mat-icon>
                                    </button> 
            
                                  </div>
      
      
                              </mat-form-field>
      
                              
                              <div *ngIf="field.fieldName == 'Address'" class="inOline">
      
                                <div class="divide">
                                  <mat-form-field>
                                    <input type="text" placeholder="City" [(ngModel)]="cityValue" aria-label="Number" matInput
                                      (input)="searchCity($event.target.value)" formControlName="City"
                                      [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let option of cityOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                </div>
      
                                <div class="divide">
                                  <mat-form-field>
      
                                    <mat-select [disabled]="field.rolePermission==1" [(ngModel)]="stateValue"
                                      formControlName="State" placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
      
                                <div class="divide">
                                  <mat-form-field>
                                    <input type="text" [(ngModel)]="zipValue" placeholder="Zip Code" aria-label="Number"
                                      matInput (input)="searchZip($event.target.value)" formControlName="ZipCode"
                                      [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #ZipCode="matAutocomplete">
                                      <mat-option *ngFor="let option of zipOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                </div>
      
      
      
      
                              </div>
                             
      
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more
                            </span>
                          </div>
                          <div class="multipleBlock" *ngIf="field.fieldName == 'Email'">
                            <div class="multype" *ngFor="let element of dynamicArray; let i = index">
      
                              <div class="primaryEmail">
      
                                <mat-form-field class="mulDropdown" appearance="">
                                  <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                    formControlName="{{ element.fieldName + 'option' }}"
                                    placeholder="{{ element.placeholderVal }}">
                                    <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                        let names of element.fieldNames;
                                        trackby: fieldNameID
                                      ">{{ names.fieldName }}</mat-option>
                                  </mat-select>
                                </mat-form-field>
      
                              
                              </div>
      
                              <mat-form-field>
                                <input matInput placeholder="Add Email" [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1"
                                  pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}" />
                              </mat-form-field>
      
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more
                            </span>
                          </div>
      
                          <div class="multipleBlock" *ngIf="field.fieldName == 'Phone'">
                            <div class="multype" *ngFor="let element of dynamicArrayPhone; let i = index">
                              <mat-form-field class="mulDropdown" appearance="">
                                <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                  formControlName="{{ element.fieldName + 'option' }}"
                                  placeholder="{{ element.placeholderVal }}">
                                  <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                                </mat-select>
                              </mat-form-field>
      
                              <mat-form-field>
                                <input matInput placeholder="Add Phone" [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}" mask="(000) 000-0000"
                                  [readonly]="field.rolePermission==1" />
                              </mat-form-field>
      
      
      
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more
                            </span>
                          </div>
      
                          <div class="multipleBlock" *ngIf="field.fieldName == 'Address'">
                            <div class="multype" *ngFor="let element of dynamicArrayAddress; let i = index">
                              <mat-form-field class="mulDropdown" appearance="">
                                <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                  formControlName="{{ element.fieldName + 'option' }}"
                                  placeholder="{{ element.placeholderVal }}">
                                  <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                                </mat-select>
                              </mat-form-field>
      
                              <mat-form-field>
                                <input matInput placeholder="Add Address" [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName }}" [readonly]="field.rolePermission==1" />
                              </mat-form-field>
      
                              <div *ngIf="element.address.length>0" class="inOline">
                                <ng-container *ngFor=" let adr of element.address;">
      
      
                                 
                                  <input *ngIf="adr.childFieldType==3" placeholder="City" [ngModel]="adr.fieldValue"
                                    aria-label="Number" matInput (input)="searchCity($event.target.value)"
                                    formControlName="City{{(i + 1) }}" [matAutocomplete]="auto"
                                    [readonly]="field.rolePermission==1">
                                  <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let option of cityOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                
                                  <mat-select [disabled]="field.rolePermission==1" [ngModel]="adr.fieldValue"
                                    *ngIf="adr.childFieldType==2" formControlName="State{{ (i + 1) }}" placeholder="State">
                                    <mat-option>None</mat-option>
                                    <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                  </mat-select>
                                 
                                  <input *ngIf="adr.childFieldType==4" placeholder="Zip Code" [ngModel]="adr.fieldValue"
                                    aria-label="Number" matInput (input)="searchZip($event.target.value)"
                                    formControlName="ZipCode{{ (i + 1) }}" [matAutocomplete]="ZipCode"
                                    [readonly]="field.rolePermission==1">
                                  <mat-autocomplete #ZipCode="matAutocomplete">
                                    <mat-option *ngFor="let option of zipOption" [value]="option">
                                      {{option}}
                                    </mat-option>
                                  </mat-autocomplete>
                                 
      
                                </ng-container>
      
                              </div>
                              <div *ngIf="element.address.length==0" class="inOline">
      
      
      
                                <div class="divide">
                                  <mat-form-field>
                                    <input placeholder="City" aria-label="Number" matInput
                                      (input)="searchCity($event.target.value)" formControlName="City{{(i + 1) }}"
                                      [matAutocomplete]="auto" [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #auto="matAutocomplete">
                                      <mat-option *ngFor="let option of cityOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                </div>
      
      
                                <div class="divide">
                                  <mat-form-field>
                                    <mat-select [disabled]="field.rolePermission==1" formControlName="State{{ (i + 1) }}"
                                      placeholder="State">
                                      <mat-option>None</mat-option>
                                      <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
      
      
                                <div class="divide">
                                  <mat-form-field>
                                    <input placeholder="Zip Code" aria-label="Number" matInput
                                      (input)="searchZip($event.target.value)" formControlName="ZipCode{{ (i + 1) }}"
                                      [matAutocomplete]="ZipCode" [readonly]="field.rolePermission==1">
                                    <mat-autocomplete #ZipCode="matAutocomplete">
                                      <mat-option *ngFor="let option of zipOption" [value]="option">
                                        {{option}}
                                      </mat-option>
                                    </mat-autocomplete>
                                  </mat-form-field>
                                </div>
      
      
      
      
                              </div>
      
      
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more
                            </span>
                          </div>
      
                          <div class="multipleBlock" *ngIf="field.fieldName == 'WebSite'">
                            <div class="multype" *ngFor="let element of dynamicArrayWebsite; let i = index">
                              <mat-form-field class="mulDropdown" appearance="">
                                <mat-select [ngModel]="element.fieldNameID" (selectionChange)="clearPlaceholder($event)"
                                  formControlName="{{
                                    element.fieldName + 'option'
                                  }}" placeholder="{{ element.placeholderVal }}">
                                  <mat-option value="{{ names.fieldNameID }}" *ngFor="
                                      let names of element.fieldNames;
                                      trackby: fieldNameID
                                    ">{{ names.fieldName }}</mat-option>
                                </mat-select>
                              </mat-form-field>
      
                              <mat-form-field>
                                <input matInput placeholder="WebSite" [(ngModel)]="element.fieldValue"
                                  formControlName="{{ element.fieldName + (i + 1) }}" [readonly]="field.rolePermission==1" />
                              </mat-form-field>
      
      
      
                            </div>
                            <span class="addmore" (click)="addMore(field.fieldName)" *ngIf="field.fieldNames.length > 0">
                              Add more
                            </span>
                          </div>
                        </ng-container>
                      </ng-container> -->
      
                      <!-- <mat-form-field *ngIf="field.fieldName == 'Name'">
                        <input matInput [required]="field.isRequired" [(ngModel)]="transactionUserName"
                          placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                        <mat-error *ngIf="
                            myFormGroup.get(field.fieldName).invalid &&
                            (myFormGroup.get(field.fieldName).dirty ||
                              myFormGroup.get(field.fieldName).touched)
                          ">
                          <span *ngIf="myFormGroup.get(field.fieldName).errors.required">This field is mandatory.</span>
                        </mat-error>
                      </mat-form-field> -->
      
                      <mat-form-field *ngIf="field.fieldName != 'Name'">
      
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                          placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                      </mat-form-field>
      
                    </div>
      
                    <div *ngSwitchCase="'Textarea'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <textarea [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                          placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1"></textarea>
                      </mat-form-field>
                    </div>
      
                    <div *ngSwitchCase="'Number'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput (keypress)="numberOnly($event)"
                          placeholder="{{ field.fieldName }}" [(ngModel)]="field.fieldValue"
                          formControlName="{{ field.fieldName }}" [readonly]="field.rolePermission==1" />
                      </mat-form-field>
                    </div>
      
                    <div *ngSwitchCase="'Currency'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                          [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                      </mat-form-field>
                    </div>
      
                    <div *ngSwitchCase="'Address'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput placeholder="{{ field.fieldName }}"
                          [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                      </mat-form-field>
                    </div>
      
                    <div *ngSwitchCase="'URL'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput [(ngModel)]="field.fieldValue"
                          placeholder="{{ field.fieldName }}" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                      </mat-form-field>
                    </div>
      
                    <div *ngSwitchCase="'Date'">
                      <mat-form-field>
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <input [required]='field.isRequired' matInput [matDatepicker]="basicDatepicker"
                          [(ngModel)]="field.fieldValue" formControlName="{{ field.fieldName }}"
                          [readonly]="field.rolePermission==1" />
                          <mat-icon *ngIf="field.fieldValue" matDatepickerToggleIcon class="mat-icon-Cleardate" (click)="clearDate(field)">clear</mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #basicDatepicker></mat-datepicker>
                      </mat-form-field>
                    </div>
      
      
      
                    <ng-container *ngSwitchCase="'Dropdown'">
                      <mat-form-field *ngIf="field.fieldName == 'Type'">
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <mat-select [required]='field.isRequired' [(ngModel)]="TypeIdDrp"
                          formControlName="{{ field.fieldName }}"
                          (selectionChange)="getCoreUserDetailsOnTypeChange($event,field.fieldName)">
                          <mat-option *ngFor="let typelist of TypeListForDropDown" [value]="typelist.subFolderID">
                            {{typelist.folderName}}
                          </mat-option>
                        </mat-select>
      
                      </mat-form-field>
      
                      <mat-form-field *ngIf="field.fieldName != 'Type'">
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <mat-select [required]='field.isRequired' [ngModel]="getddlSelectedVal(field.fieldName)"
                          formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                          <mat-option *ngFor="let drp of getdropdownlist(field.fieldName)" [value]="drp">
                            {{ drp }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
      
      
                    <ng-container *ngSwitchCase="'MultiSelect'">
      
                      <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <mat-chip-list [required]='field.isRequired' #chipList aria-label="Tag selection">
                          <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                            (removed)="remove(tag)">
                            {{tag}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                          </mat-chip>
                          <input placeholder="Add Tags" #fruitInput [formControl]="fruitCtrl" [matAutocomplete]="auto"
                            [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="add($event)">
                        </mat-chip-list>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                          <mat-option *ngFor="let tag of filteredFruits | async" [value]="tag">
                            {{tag}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
      
                      <mat-form-field *ngIf="field.fieldName != 'Tags'">
                        <mat-label>{{ field.fieldName }}</mat-label>
                        <mat-select [required]='field.isRequired' multiple [ngModel]="getMultiddlSelectedVal(field.fieldName)"
                          formControlName="{{ field.fieldName }}" [disabled]="field.rolePermission==1">
                          <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                            {{ muldrp }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
      
      
                    <ng-container *ngSwitchCase="'Checkbox'">
                      <div class="checkList">
                        <mat-label>{{ field.fieldName }}</mat-label>
      
                        <div class="allCheckList" *ngFor="let chk of getCheckBoxlist(field.fieldName)">
                          <mat-checkbox color="primary" [disabled]="field.rolePermission==1"
                            [checked]="isChecked(field.fieldName, chk)" (change)="OnChange($event, chk, field.fieldID)">
                            {{ chk }}
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
      
                  </div>
                </ng-container>
      
                <div class="actionBtn">
                  
                  <button mat-flat-button class="calltoaction" type="submit"             
                  (click)="onSubmit(myFormGroup.value, myFormGroup)" color="primary">
                    Save
                    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
                    </mat-spinner></mat-icon>
                  </button>
                </div>
              </form>
            </div>
          </div>

      


      </div>

    

    </mat-tab>   

   

    <mat-tab label="Activity" *ngIf="fileFoldeTypeId==2">
      <div class="touches_holder">
        <div class="addtouch">
          <button mat-stroked-button color="primary" (click)="addTouch()" ><mat-icon>add</mat-icon> Add Activity</button>
        </div>

        <div class="touches" *ngFor="let touch of allFormFolderTouchesList">
          <h4 class="">
            <mat-icon class="note" *ngIf="touch.touchTypeName=='Note'">event_note</mat-icon>
            <mat-icon class="call" *ngIf="touch.touchTypeName=='Phone Call'">local_phone</mat-icon>
            <mat-icon class="email" *ngIf="touch.touchTypeName=='Email'">mail</mat-icon>
            <mat-icon class="meeting" *ngIf="touch.touchTypeName=='Meeting'">recent_actors</mat-icon>
            <mat-icon class="others" *ngIf="touch.touchTypeName=='Other'">add_to_photos</mat-icon>
            <mat-icon class="others" *ngIf="touch.touchTypeName=='Log'">text_snippet</mat-icon>
            <mat-icon *ngIf="touch.touchTypeName != 'Note' && touch.touchTypeName != 'Phone Call' && touch.touchTypeName != 'Email' && touch.touchTypeName != 'Meeting'
              && touch.touchTypeName != 'Other' && touch.touchTypeName != 'Log'">touch_app</mat-icon>
        
            <span> {{touch.createdByFirstName|titlecase}} {{touch.createdByLastName|titlecase}}
              added {{touch.touchTypeName}} on {{touch.createdOn+'Z' | date:'MM/dd/yyyy'}} - {{touch.touchStatusName}}</span>
        
          </h4>
        
          <div class="timeStamp">
        
        
            <div class="time">
              <span *ngIf="touch.startDate != null"> {{touch.startDate+'Z' | date:'MM/dd/yyyy'}}</span>
              <span *ngIf="touch.touchDate != null"> {{touch.touchDate+'Z' | date:'MM/dd/yyyy'}}</span>
              <span *ngIf="touch.startTime != null || touch.touchTime != null" class="sep">-</span>
              <span *ngIf="touch.startTime != null"> {{touch.startTime | date:'h:mm a'}} </span>
              <span *ngIf="touch.touchTime != null"> {{touch.touchTime | date:'h:mm a'}} </span>
            </div>               
            <p>
              {{ touch.touchNote }}
            </p>  
          </div>
        </div>
      </div>
    </mat-tab>   
</mat-tab-group>

<div class="notselected" *ngIf="folderDetails == '' || folderDetails == undefined">
  <mat-icon>speaker_notes_off</mat-icon>
  <p>Select a file or folder to view its details</p>
</div>
